import { render, staticRenderFns } from "./instrumentStatus_TRA.vue?vue&type=template&id=ca3065e2&"
import script from "./instrumentStatus_TRA.vue?vue&type=script&lang=js&"
export * from "./instrumentStatus_TRA.vue?vue&type=script&lang=js&"
import style0 from "./instrumentStatus_TRA.vue?vue&type=style&index=0&id=ca3065e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports